import React from 'react'
import {Mail} from 'lucide-react'

export default function Pricing() {
  return (
    <section id="pricing" className="py-16 bg-white">
      <div className="max-w-2xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-[#003D23] mb-2">
            Acesso imediato
          </h2>
        </div>

        <div className="bg-gradient-to-br from-[#006B3F] to-[#003D23] rounded-2xl p-8 text-white text-center shadow-xl">
          <div className="mb-6">
            <div className="text-5xl font-bold mb-2">R$ 12,90</div>
            <div className="text-xl text-gray-200 mb-1">à vista</div>
            <div className="text-sm text-gray-300">Menos de R$ 0,50 por dia para estudar antes do edital.</div>
          </div>

          {/* Security Note - Above Button */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 mb-6 text-left">
            <div className="flex items-start gap-3 mb-3">
              <span className="text-2xl">🔒</span>
              <h4 className="text-lg font-bold">Pagamento 100% seguro via Kirvano</h4>
            </div>
            <p className="text-sm text-gray-200 mb-3">
              O pagamento é processado pela Kirvano, uma plataforma de pagamentos digitais amplamente utilizada no Brasil.
            </p>
            <div className="flex items-start gap-2">
              <span className="text-yellow-400 font-bold">⚠️</span>
              <div className="text-sm text-gray-200">
                <p className="mb-1">O CPF é exigido apenas para a emissão da compra, conforme as regras da plataforma.</p>
                <p>Seus dados são protegidos e não ficam públicos.</p>
              </div>
            </div>
          </div>

          <a
            href="https://pay.kirvano.com/573317d1-f389-4a99-9cc3-9e77f25470e2"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full bg-[#FDB913] text-[#003D23] py-4 rounded-lg text-xl font-bold hover:bg-[#fdc740] transition-all duration-300 shadow-lg hover:shadow-[#FDB913]/50 hover:scale-105"
          >
            👉 ACESSAR O MATERIAL AGORA
          </a>

          <p className="text-sm text-gray-300 mt-4">
            Pagamento seguro via Kirvano
          </p>

          {/* Micro Social Proof */}
          <div className="mt-6 pt-6 border-t border-white/20">
            <p className="text-sm text-gray-200">
              📚 Material usado como base por candidatos que se preparam antes do edital.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}